<template>
    <b-tabs>
      <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
      <b-tab title="Select Audience" :active="tabs.audience" :disabled="!tabs.audience">
        <audience-tab :listings="campaign.listings" @click="onAudienceNext"/>
      </b-tab>
      <b-tab title="Details" :active="tabs.details" :disabled="!tabs.details">
        <campaign-form :campaign="campaign"/>
        <b-button v-on:click="onDetailsNext">
          Next
        </b-button>
      </b-tab>
      <b-tab title="Design Mail" :active="tabs.designMail" :disabled="!tabs.designMail">
        <mail-editor @save="onSaveDesign"/>
      </b-tab>
      <b-tab title="Schedule / Send" :active="tabs.schedule" :disabled="!tabs.schedule">
        <schedule-send-tab :campaign="campaign"/>
      </b-tab>
    </b-tabs>
</template>

<script>
    import CampaignForm from "../../components/newsletter/Campaign/CampaignForm";
    import {Campaign} from "@/models/NewsLetter/Campaign";
    import MailEditor from "@/components/newsletter/Campaign/MailEditor";
    import SelectAudience from "@/components/newsletter/Campaign/AddCampaign/SelectAudience";
    import ScheduleCampaign from "@/components/newsletter/Campaign/AddCampaign/ScheduleCampaign";
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import SelectedAudience from "../../components/newsletter/Campaign/AddCampaign/SelectedAudience";
    import AudienceTab from "../../components/newsletter/Campaign/AddCampaign/AudienceTab";
    import ScheduleSendTab from "../../components/newsletter/Campaign/AddCampaign/ScheduleSendTab";

    export default {
        name: "AddCampaign",
        components: {
          ScheduleSendTab,
          AudienceTab,
          SelectedAudience,
          ScheduleCampaign,
          SelectAudience,
          MailEditor,
          CampaignForm,
          VueLoading,
        },
        data(){
            return {
              campaign: new Campaign(),
              tabs: {
                audience: true,
                details: false,
                designMail: false,
                schedule: false,
              },
              isLoading: false,
            }
        },
        methods: {
          onAudienceNext(listings) {
            this.campaign.listings = listings;
            this.activateTab('details');
          },
          onDetailsNext() {
            this.activateTab('designMail');
          },
          onSaveDesign(html) {
            this.campaign.mailShotHtml = html;
            this.activateTab('schedule');
          },
          activateTab(tab) {
            for (const property in this.tabs) {
              if (tab === property) {
                this.tabs[property] = true;
                continue;
              }
              this.tabs[property] = false;
            }
          }
        }
    }
</script>
